/**
 * @description 通用接口api
 * @returns promise对象
 * @author xurui
 * @date 2020/06/18
 */
import BaseApi from '../base'; // 基础api配置对象

class FarmerApi extends BaseApi {
	constructor() {
		super();
		this.defautUrl = '/';
		this.defautUrl_JAVA = '/nms/dubbo/';
	}

	// index(data) {
	// 	const _url = this.defautUrl_JAVA + `dongfeng/appApi/scan/query`;
	// 	return this.post(_url, data);
	// }
	index(data) {
		const _url = this.defautUrl_JAVA + `mallcenter/appApi/goods/tidHash`;
		return this.post(_url, data);
	}
	// index2(data) {
	// 	const _url = this.defautUrl + `scan/index2`;
	// 	return this.post(_url, data);
	// }

	// orderdetails(data) {
	// 	const _url = this.defautUrl + `scan/orderdetails`;
	// 	return this.post(_url, data);
	// }

	// shopdetails(data) {
	// 	const _url = this.defautUrl + `scan/shopdetails`;
	// 	return this.post(_url, data);
	// }
	// getGoods(data) {
	// 	const _url = this.defautUrl + `scan/address1`;
	// 	return this.post(_url, data);
	// }
	// getBuys(data) {
	// 	const _url = this.defautUrl + `scan/address2`;
	// 	return this.post(_url, data);
	// }
	// search(data) {
	// 	const _url = this.defautUrl + `scan/search`;
	// 	return this.post(_url, data);
	// }
	// volumesList(data) {
	// 	const _url = this.defautUrl_JAVA + `adminuser/appApi/sls/website/volumes/list`;
	// 	return this.post_java(_url, data);
	// }
}
export default new FarmerApi();
